import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TILES_CONVERTER_TOKEN, TilesConverter } from './tiles.component.converter'
import { TILES_ITEM_CONVERTER_TOKEN, TilesItemConverter } from './tile-item/tiles-item.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        tilesFeature: {
          module: () => import('./tiles.module').then((m) => m.TilesModule),
          cmsComponents: ['tiles'],
        },
      }
    }),
    {
      provide: TILES_CONVERTER_TOKEN,
      useClass: TilesConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        tiles: TILES_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TILES_ITEM_CONVERTER_TOKEN,
      useClass: TilesItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        tiles_item: TILES_ITEM_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TilesFeatureModule {}
